/** RTL language detection and content direction helpers. */

const RTL_CODES = new Set(["ar", "fa", "he", "ur", "ps", "sd", "ug", "yi", "ckb", "arc", "dv"]);

/** Unicode ranges for Arabic, Persian, Hebrew, etc. */
const RTL_RE = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF]/;

/** Returns "rtl" or "ltr" based on a language code (e.g. "fa", "en-US"). */
export function getContentDir(lang?: string | null): "rtl" | "ltr" {
  if (!lang) return "ltr";
  const code = lang.toLowerCase().split(/[-_]/)[0];
  return RTL_CODES.has(code) ? "rtl" : "ltr";
}

/** Extracts base language code from a full locale string (e.g. "fa-IR" → "fa"). */
export function getContentLang(lang?: string | null): string | undefined {
  if (!lang) return undefined;
  return lang.toLowerCase().split(/[-_]/)[0] || undefined;
}

/** Detects RTL characters in the first 200 chars of text. */
export function detectRtl(text: string): boolean {
  return RTL_RE.test(text.slice(0, 200));
}

// Persian-specific chars: ی پ چ ژ گ ک (not in standard Arabic)
const PERSIAN_RE = /[\u067E\u0686\u0698\u06AF\u06A9\u06CC]/;
// Hebrew range
const HEBREW_RE = /[\u0590-\u05FF]/;

/**
 * Guess RTL font from text content when no language code is available.
 * Returns "Vazirmatn" for Persian, "Cairo" for Arabic, undefined otherwise.
 */
export function detectRtlFont(text: string): string | undefined {
  const sample = text.slice(0, 500);
  if (!RTL_RE.test(sample)) return undefined;
  if (PERSIAN_RE.test(sample)) return "Vazirmatn";
  if (HEBREW_RE.test(sample)) return undefined;
  return "Cairo"; // Arabic fallback
}
